<template>
    <div>

        <!-- URGENT POPUP -->
        <v-layout v-if="urgentData && !getAppPropertyStudyAccess" row justify-center>
            <v-dialog v-model="mustShowUrgentPopup" persistent max-width="600" content-class="dialog-chatbot-urgent">
                <v-card class="no-padding">
                    <v-card-text class="text-center no-padding pf-urgent">

                        <div class="warning-ambulance" v-bind:style="getAppPropertyValue('GUI_THEME_URGENCY_COLOR_BACKGROUND') ? {'background-color': getAppPropertyValue('GUI_THEME_URGENCY_COLOR_BACKGROUND') + ' !important'}: {'background-color': '#a0001c' + ' !important'}">
                            <div class="pf-urgent-popup-texts">
                                <div style="display:block;position:relative" class="warning-icon-urgent-popup">
                                    <img src="../../../assets/svg/Emergency.svg" id="urgentPopupWarningIcon" width="104" height="104" alt="Emergency">
                                </div>

                                <div class="color-white" v-bind:style="getAppPropertyValue('GUI_THEME_URGENCY_COLOR_TEXT') ? {'color': getAppPropertyValue('GUI_THEME_URGENCY_COLOR_TEXT') + ' !important'} : {}">
                                    <h2 class="font-weight-regular title margin-bottom-s margin-top-s" id="urgentPopupDecisionItem1Headline" v-html="urgentData.decisionItem1Headline"></h2>
                                    <p v-if="urgentData.decisionItem1Text" id="urgentPopupDecisionItem1Text" v-html="urgentData.decisionItem1Text">

                                    </p>

                                    <div v-if="urgentData.decisionItems2Texts">
                                        <br />
                                        <ul>
                                            <li v-for="(decisionItems2Text, index) in urgentData.decisionItems2Texts"
                                                :id="'urgentPopupDecisionItems2Text_' + index"
                                                v-html="decisionItems2Text"
                                            ></li>
                                        </ul>
                                    </div>

                                    <p v-if="urgentData.emergencyNumber" id="urgentPopupEmergencyNumber">Emergency number: {{ urgentData.emergencyNumber</p>
                                </div>
                            </div>
                        </div>

                    </v-card-text>
                    <v-card-actions class="text-center warning-actions">

                        <div v-if="getVoucherData !== null && typeof getVoucherData.callbackUrl !== 'undefined' && getVoucherData.callbackUrl !== null
                                              && getAppPropertyValue('PATIENT_CONSENT') === 'true'" id="patient-consent-checkbox-wrapper" class="chat-bot-urgent-popup-patient-consent-checkbox">
                            <v-checkbox
                                        v-model="consentCheckboxValue"
                                        hide-details
                                        >
                            </v-checkbox>
                            <span @click="handleConsentCheckboxClick">{{text('api.chatbot.conversationMsg.patientConsent')}}</span>
                        </div>
                        <div class="continue">
                            <v-btn v-if="getVoucherData === null"
                                   @click="goToHome()"
                                   id="btnUrgentPopupFinishAssessment"
                                   class="btn-evaluation bg-color-primary-important"
                                  >{{text('api.button.urgentPopup')}}</v-btn>
                            <v-btn v-else-if="getVoucherData !== null && typeof getVoucherData.callbackUrl !== 'undefined' && getVoucherData.callbackUrl !== null"
                                   @click="submitConsentForm"
                                   :disabled="consentCheckboxValue === false && getAppPropertyValue('PATIENT_CONSENT') === 'true'"
                                   id="btnUrgentPopupFinishAssessmentGoToUrl"
                                   class="btn-evaluation bg-color-primary-important"
                                  >{{text('api.button.continue')}}</v-btn>

                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import WarningIcon from "../../../common/components/svg/shared/warningIcon";
import Vue from "vue";

export default {
        name: 'ChatBotUrgentPopup',
        components: {
            WarningIcon
        },
        data() {
            return {
                consentCheckboxValue: false,
                checkBoxPlugin: Vue.CheckBox.checkBoxSvg
             }
        },
        computed: {
            ...mapGetters({
                urgentData: 'AssessmentAlertsStore/getUrgentData',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                decisionColor: 'AssessmentAlertsStore/getDecisionColor',
                getAssessmentStatuses: "ChatBotStore/getAssessmentStatuses",
                getVoucherData: 'TranslationStore/getVoucherData',
                getVoucherCallbackData: 'TranslationStore/getVoucherCallbackData',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            })
        },

        watch: {
            // We watch the consent checkbox to replace it with a svg when it is checked.
            consentCheckboxValue(newValue, oldValue) {
                if(newValue === true) {
                    let that = this;
                    setTimeout(function () {
                        let patientConsentCheckbox = document.querySelector('#patient-consent-checkbox-wrapper .input-group');
                        let iconCheckBox = patientConsentCheckbox.getElementsByClassName('icon--checkbox')
                        for (let j = 0; j < iconCheckBox.length; j++) {
                            iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                        }
                    }, 10)
                }
            }
        },

        created() {

            if (this.getVoucherData !== null && this.getVoucherCallbackData !== null) {
                this.UtilitiesPlugin.createFormForData(this.getVoucherData.callbackUrl, this.getVoucherCallbackData.callbackDataMap, this.getAppPropertyValue('PATIENT_CONSENT'));
            }
        },

        methods: {

            goToHome() {

                this.$router.push({ name: "PF_ChatBotPage" }).then(() => {
                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                });
            },

            /* Initial method, not used currently. Actual methods inspired from this method */
            goToChatbotEvaluationPage() {

                this.$store.commit("ChatBotStore/setCurrentAssessmentStatus", this.getAssessmentStatuses.EVALUATED);

                let promiseLoadEvaluationData = this.$store.dispatch("ChatBotStore/loadEvaluationData");
                promiseLoadEvaluationData.then(() => {
                    this.$store.commit('AssessmentAlertsStore/setMustShowUrgentPopup', false);

                    this.$router.push({name: 'PF_ChatBotEvaluationPage'});
                });
                promiseLoadEvaluationData.catch(() => {
                    console.log("Couldn't evaluate assessment. Please try again.");
                });

            },

            handleConsentCheckboxClick() {
                this.consentCheckboxValue = !this.consentCheckboxValue;
            },

            submitConsentForm() {
                if (this.getAppPropertyValue('PATIENT_CONSENT') === 'true') {
                    let consentFormField = document.getElementById("consentFormId");
                    if (consentFormField != null) {
                        consentFormField.value = this.consentCheckboxValue;
                    } else {
                        console.warn("Unexpected error! Couldn't find consentFormId.");
                    }
                }

                this.UtilitiesPlugin.submitDataForm(true, this.consentCheckboxValue);
            }
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>



    .warning-ambulance {
        position:relative;
        background-color: $color-block-background;
        height:auto !important;
        width:100% !important;
        color: $color-headings-text;
        padding: 20px 20px 0 20px;

        ul li {
            list-style-type: none;
        }
    }

    .close-warning {

        padding-bottom: 50px;



        span {

            float: right;
            padding: 10px;

            .icon {
                color: $color-gray;
            }

            &:hover {
                cursor: pointer;
            }
        }


    }

    .warning-actions {
        display: block;
        padding: 20px 0 20px;
        border-top: none !important;

        .continue {
            padding: 0 20px;

            &:hover {
                cursor: pointer;
            }

            .btn {
                border-radius: 20px;
                font-weight: $font-weight-default;

                .btn__content {
                    padding: 7px 65px;
                }
            }
        }
    }

    .no-padding.card {
        border-radius: 20px !important;
    }

    h2.title {
        font-weight: $font-weight-bold;
       // color: $color-brand-primary;
        font-size: $font-size-big;
    }

.pf-urgent-popup-texts {
   max-height: 65vh;
    overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/ChatBotUrgentPopup.vue